/**
 * Represent the type of a position
 */
// eslint-disable-next-line etc/no-const-enum
export var PositionType;
(function (PositionType) {
    /**
     * At the beginning of a node
     */
    PositionType[PositionType["Begin"] = 0] = "Begin";
    /**
     * At the end of a node
     */
    PositionType[PositionType["End"] = -1] = "End";
    /**
     * Before a node
     */
    PositionType[PositionType["Before"] = -2] = "Before";
    /**
     * After a node
     */
    PositionType[PositionType["After"] = -3] = "After";
})(PositionType || (PositionType = {}));
//# sourceMappingURL=PositionType.js.map